const QUERY_KEYS = {
  affordaDetails: ({ authUserId }) => ['affordaDetails', authUserId],
  getAffordaPortalFormByPortalUserId: ({
    organizationId,
    propertyId,
    portalUserId,
  }) => [
    'getAffordaPortalFormByPortalUserId',
    organizationId,
    propertyId,
    portalUserId,
  ],
  householdBalance: ({ organizationId, propertyId, householdId }) => [
    'getHouseholdBalance',
    organizationId,
    propertyId,
    householdId,
  ],
  householdApplicationFees: ({ organizationId, propertyId, householdId }) => [
    'getHouseholdApplicationFees',
    organizationId,
    propertyId,
    householdId,
  ],
  householdMembers: ({ organizationId, propertyId, householdId }) => [
    'getHouseholdMembers',
    organizationId,
    propertyId,
    householdId,
  ],
  householdMembersEligibility: ({
    organizationId,
    propertyId,
    householdId,
    affordableProgramId,
  }) => [
    'getHouseholdMembersEligibility',
    organizationId,
    propertyId,
    householdId,
    affordableProgramId,
  ],
  primaryFormData: ({ organizationId, propertyId }) => [
    'getPrimaryFormData',
    organizationId,
    propertyId,
  ],
  secondaryFormData: ({
    organizationId,
    propertyId,
    secondaryMembersApplicantIds,
  }) => [
    'getSecondaryFormData',
    organizationId,
    propertyId,
    secondaryMembersApplicantIds,
  ],
  prospectPreferences: ({ householdProspectId }) => [
    'prospectPreferences',
    householdProspectId,
  ],
  householdMemberStatus: ({
    organizationId,
    propertyId,
    customerId,
    householdId,
  }) => [
    'getHouseholdMemberStatus',
    organizationId,
    propertyId,
    customerId,
    householdId,
  ],
};

export default QUERY_KEYS;
